(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ntd-header"]) return;
  try {
    
  const focusNtdDepartment = () => {
    document.getElementById('ntd-departments')?.focus({ preventScroll: true });
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenu = event.target.closest('.ntd-header details[open]');
    if (openMenu) {
      openMenu.open = false;
      openMenu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.ntd-header a, .ntd-home a[href="#ntd-departments"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

    const destination = new URL(link.href, window.location.href);
    const samePageDepartment = destination.origin === window.location.origin && destination.pathname === window.location.pathname && destination.hash === '#ntd-departments';
    const menu = link.closest('.ntd-mobile-menu');
    if (menu) {
      menu.open = false;
      if (!samePageDepartment) menu.querySelector('summary').focus({ preventScroll: true });
    }
    if (samePageDepartment) requestAnimationFrame(focusNtdDepartment);
  });

  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#ntd-departments') focusNtdDepartment();
  });
  if (window.location.hash === '#ntd-departments') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusNtdDepartment, { once: true });
    else focusNtdDepartment();
  }

  let ntdCartRevision = 0;
  let ntdHistoryCartController = null;
  const updateNtdBag = (count) => {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-ntd-cart-count]').forEach((element) => {
      const label = count === 1 ? element.dataset.countLabelOne : element.dataset.countLabelOther;
      if (!label || element.textContent === `(${count})`) return;
      const cartLink = element.closest('.ntd-cart');
      cartLink.setAttribute('aria-label', `${cartLink.dataset.bagLabel}: ${label.replaceAll('__NTD_COUNT__', String(count))}`);
      element.textContent = `(${count})`;
    });
  };
  const ntdNavigationType = () => {
    const entry = globalThis.performance?.getEntriesByType?.('navigation')[0];
    return entry?.entryType === 'navigation' ? entry.type : undefined;
  };
  const reconcileNtdHistoryCart = async () => {
    ntdHistoryCartController?.abort();
    const controller = new AbortController();
    const revision = ntdCartRevision;
    ntdHistoryCartController = controller;
    try {
      const response = await fetch(`${Theme.routes.cart_url}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
      });
      if (!response.ok || controller.signal.aborted || ntdHistoryCartController !== controller) return;
      const cart = await response.json();
      if (controller.signal.aborted || ntdHistoryCartController !== controller || revision !== ntdCartRevision) return;
      updateNtdBag(cart?.item_count);
    } catch (_) {
    } finally {
      if (ntdHistoryCartController === controller) ntdHistoryCartController = null;
    }
  };
  window.addEventListener('pageshow', (event) => {
    if (event.persisted || ntdNavigationType() === 'back_forward') reconcileNtdHistoryCart();
  });
  if (document.readyState === 'complete' && ntdNavigationType() === 'back_forward') reconcileNtdHistoryCart();

  import('@shopify/events').then(({ StandardEvents }) => {
    document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
      const revision = ++ntdCartRevision;
      ntdHistoryCartController?.abort();
      ntdHistoryCartController = null;
      event.promise?.then(({ cart }) => {
        if (revision === ntdCartRevision) updateNtdBag(cart?.totalQuantity);
      }).catch(() => {});
    });
  }).catch(() => {});

  } catch(e) { console.error(e); }
})();
})();
